<template>
<div>
     <v-app-bar id="home-app-bar3" v-if="!isLoading" style="margin-top:124px" app :color="(settings[0] ? settings[0].color : '#2F839D')" elevation="1" height="50">

          <div>
               <v-tabs class=" hidden-sm-and-down" color="#fff" optional>
                    <v-tab :style="'color:#fff;background-color:' +(settings[0] ? settings[0].color : '#2F839D')" v-for="(i,index) in data"
                    :key="index" :to="{path:('vip/' + i.route == 'accueil' ? '' : i.route), params: { id: index }}" :ripple="false" active-class="text--primary" class="font-weight-bold" min-width="96" text>
                         {{ (localLang == 'fr' && i.nameAr && i.nameFr) ? i.nameFr : i.nameAr  }}
                    </v-tab>
               </v-tabs>
          </div>
          <v-app-bar-nav-icon justify-end class="hidden-md-and-up" color="#fff" @click="drawer = !drawer"></v-app-bar-nav-icon>
          
     </v-app-bar>
     <v-skeleton-loader v-else ref="skeleton" type="table-thead"></v-skeleton-loader>
     <home-drawer v-model="drawer" :items="data" />
</div>
</template>

<script>
export default {
     components: {
          HomeDrawer: () => import('./Drawer'),
     },
     data: () => ({  
          drawer: null,  
     }),

     methods: {
          handleScroll(event) {
               let doc1 = document.getElementById("home-app-bar3")
               if ((event.path[1].pageYOffset > 70) && doc1)  {
                    doc1.style.top = "-125px"
                    doc1.style.transition = "0.8s"
               } else {
                    doc1.style.top = "0px"
                    doc1.style.transition = "0.5s"
               }
          },
          test() {
               this.pages.filter(e => {
                    return e 
               })
          }
     },
     computed: { 
          data() {
               return this.myArray2.filter(e => e.status != 0) 
          }
     },
     created() {
      
          window.addEventListener('scroll', this.handleScroll);
     },
     destroyed() {
          window.removeEventListener('scroll', this.handleScroll);
     },

}
</script>

<style scoped>
.theme--light.v-application .text--primary {
     color: rgba(173, 241, 253, 0.87) !important;
     font-style: italic;
}
</style><style> 
.v-toolbar__content,
.v-toolbar__extension {
     justify-content: center !important;
}
</style>
